import React, { useState, useEffect, useContext } from 'react';

import Header from './Header';
import Footer from './Footer';
import FooterMobile from './FooterMobile';
import Loading from '../pages/common/Loading';
import DiCheck from '../pages/user/DiCheck';

import Theme from './Theme';
import NoDataField from '../helpers/NoDataField';
import { MainStyled, JWTCookieCheckLayOut } from '../styles/layOutStyles';
import { getCookie, removeCookie, setCookie } from '../helpers/cookies';
import { APP_PREFIX, storageData, VALIDATECODE } from '../constants/index';
import { connect } from 'react-redux';
import { LayoutContext } from '../context/layoutContext';
import { logOut } from './Topbar';

import jwt_decode from 'jwt-decode';
import { tokenRefresh } from '../constants/AxiosInstance';
import { setData } from '../constants/api_index';

const JWT_KEY = 'ftv_jwt';
const TOKEN = getCookie(JWT_KEY);

const Layout = ({ children, headerHide, headerTitle, loading, LoadingbackColorOff, home, search, userInfo }) => {
  const { matchese } = useContext(LayoutContext);

  const stData = storageData && JSON.parse(storageData);

  const [layout, setLayout] = useState(false);
  const [diCheck, setDiCheck] = useState(false);
  const [delay, setDelay] = useState('');

  useEffect(() => {
    // DiCode 없는 유저 체크
    if (userInfo?.isDel) {
      logOut();
    }

    if (window?.location?.pathname !== '/login') {
      if (userInfo && !userInfo[VALIDATECODE]) {
        setDiCheck(true);
      }
    }
  }, [userInfo]);

  useEffect(() => {
    // storageData Check Reload
    if (!stData) reLoad();
  }, [storageData]);

  useEffect(() => {
    // 결제 및 핸드폰 인증창 쿠키
    let pay = `${APP_PREFIX}_pay`;
    let auth = `${APP_PREFIX}_auth`;

    let payCookie = getCookie(pay);
    let authCookie = getCookie(auth);

    if (payCookie) removeCookie(pay);
    if (authCookie) removeCookie(auth);
  }, []);

  useEffect(() => {
    if (layout) return;
    let cookie = getCookie(`${APP_PREFIX}_user`);

    if (!layout && stData) {
      if (cookie && userInfo?.id) {
        setLayout(true);
      } else if (!cookie) {
        setLayout(true);
      }
    }
  }, [layout, userInfo]);

  // 토큰 리프레쉬
  useEffect(() => {
    if (TOKEN) {
      try {
        const data = jwt_decode(TOKEN, { complete: true });
        const { exp } = data;

        // console.log('TOKEN -', new Date(Number(exp * 1000)));

        // 토큰 Refresh
        if (Date.now() >= exp * 1000) {
          tokenRefresh().then(res => {
            if (res) {
              window.location.reload();
            }
          });
        }
      } catch (error) {
        // console.log(error);
      }
    }
  }, [TOKEN]);

  // 일일 접속 확인
  useEffect(() => {
    const PREFIX = `${APP_PREFIX}_loginLog`;

    const log = getCookie(PREFIX);

    if (log !== 'true') {
      setData('loginLog/simple', {}).then(res => {
        var today = new Date();
        today.setDate(today.getDate() + 1);

        setCookie(PREFIX, true, { expires: today, path: '/' });
      });
    }
  }, []);

  const reLoad = () => {
    if (delay) clearInterval(delay);

    let _delay = setTimeout(() => {
      window.location.reload();
    }, [1500]);

    setDelay(_delay);
  };

  return (
    <Theme>
      {layout ? (
        <div id='main'>
          {!headerHide && <Header headerTitle={headerTitle} search={search} />}
          <MainStyled home={home} search={search}>
            {children}
          </MainStyled>
          {matchese ? <FooterMobile /> : <Footer />}
        </div>
      ) : (
        <LayOutJWTCookieCheck />
      )}
      <Loading open={loading} backColorOff={LoadingbackColorOff} />
      {userInfo && <DiCheck open={diCheck} userInfo={userInfo} />}
    </Theme>
  );
};

const mapStateToProps = state => {
  return {
    userInfo: state.userData.user,
  };
};

export default connect(mapStateToProps)(Layout);

const LayOutJWTCookieCheck = () => {
  const [cnt, setCnt] = useState(1);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    let _delay = setInterval(() => {
      setCnt(prev => prev + 1);

      if (cnt === 2) {
        setShowText(true);
      }

      if (cnt === 3) {
        logOut();
        clearInterval(_delay);
      }
    }, [2500]);

    return () => clearInterval(_delay);
  }, [cnt]);

  return (
    <JWTCookieCheckLayOut>
      <div className='lazy-loading-bg'>
        <span className='lazy-loading'></span>
      </div>
      {showText && (
        <NoDataField style={{ color: '#ffffff', position: 'absolute', top: '0' }}>
          접속이 지연되어 잠시 후 새로고침을 시도합니다.
        </NoDataField>
      )}
    </JWTCookieCheckLayOut>
  );
};
